import React from 'react';

import { Avatar } from '@lifepal/lifepal-design-system';

import styles from './CustomError.module.scss';

const CustomError = ({ children }) => {
  return (
    <>
      <div className={styles['not-found__wrapper']}>
        <div className={styles['not-found__wrapper--row']}>
          <div className={styles['not-found__wrapper--col']}>
            <div className={styles['not-found__wrapper--card']}>
              <div className={styles.card__left}>
                <Avatar
                  src="/media/static/images/not-found.png"
                  className={styles['card__left--image']}
                  alt="not-found"
                  width="100%"
                  height="100%"
                />
              </div>
              <div className={styles.card__right}>{children}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomError;
